import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pdf-document-headers',
  templateUrl: './pdf-document-headers.component.html',
  styleUrls: ['./pdf-document-headers.component.css']
})
export class PdfDocumentHeadersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
